import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance, axiosNewApiInstance } from "../../services/api.js";

// ! Support

// create ticket for support
export const createTicket = createAsyncThunk(
  "chat/createTicket",
  async (ticket, thunkAPI) => {
    const state = thunkAPI.getState();
    const serviceId = state.auth.userData.selectedServiceId;
    try {
      const response = await axiosNewApiInstance.post(
        `/api/v1/support/tickets`,
        ticket,
        {
          headers: {
            "company-id": serviceId,
          },
        }
      );
      console.log("createTicket", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.message,
        details: error.response?.data.detail, // Залишаємо лише необхідні дані
      });
    }
  }
);
